export const getVehicleYearsForSelect = (
    minYear = new Date().getFullYear() - 10,
    maxYear = new Date().getFullYear() + 1
) =>
    Array.from({ length: maxYear - minYear + 1 }, (_, index) =>
        String(maxYear - index)
    );
